import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { DarkThemeIcon, DropdownArrowIcon, LightThemeIcon } from '../../../assets/svg';
import { useDefaultContext } from '../../../contexts/HomeContext';
import CustomModal from '../../CustomModal';
import BlockChainModal from './BlockChainModal';
import './FilterHeader.scss';

const FilterHeader = () => {
  const { darkTheme, toggleTheme } = useTheme();
  const { chainNetwork, allChainNetwork } = useDefaultContext();
  const kalpChain = allChainNetwork?.find((item: any) => item?.blockchain === localStorage.getItem('blockchain'));
  const [showModal, setModal] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkTheme ? "dark" : "light"
    );
  }, [darkTheme]);

  const handleModal = () => {
    setModal(true)
  }

  return (
    <div className="filter-header-main">
      <div className="d-flex align-items-center">
        <div onClick={toggleTheme} className="sub-header-theme-wrapper pointer">
          {darkTheme ? <DarkThemeIcon /> : <LightThemeIcon />}
        </div>
        <div className="filter-modal-wrapper" onClick={handleModal}>
          <span className="filter-selected-chain-wrapper">{kalpChain?.blockchain?.toUpperCase()} DLT</span>
          <div className="d-flex gap-3 align-items-center blockchain-modal">
            <span className="filter-tab-dropdown">{chainNetwork?.toUpperCase()}</span>
            <DropdownArrowIcon color={darkTheme ? '#EF5F14' : 'white'} />
          </div>
        </div>
      </div>
      <CustomModal
        close
        show={showModal}
        className="block-chain-modal"
        title="Blockchain & Network"
        onHide={() => setModal(false)}
        body={<BlockChainModal  onHide={() => setModal(false)} />}
      />
    </div>
  )
}

export default FilterHeader;
